import { downloadReport } from "../utils/downloadReport ";
import axiosInstance from "./authentication/axiosInstance";

export const invoiceServices = {
    getClientJobs: async (clientId, startDate, endDate) => {
        const response = await axiosInstance.get("invoice/clientInvoice", {
            params: { clientId, startDate, endDate }
        });
        return response.data;
    },

    checkInvoiceExists: async (clientId, startDate, endDate, id) => {
        const params = { clientId, startDate, endDate };
        if (id) params.id = id;
        const response = await axiosInstance.get("/invoice/exists", { params });
        return response.data;
    },

    getPreviewInvoice: async (payload) => {
        const response = await axiosInstance.post("/invoice/preview", payload);
        return response.data;
    },

    generateInvoice: async (payload) => {
        const response = await axiosInstance.post("/invoice/generate", payload, { responseType: "blob" });

        downloadReport(response);
    },

    generateInvoiceExcel: async (payload) => {
        const response = await axiosInstance.post("/invoice/generateExcel", payload, { responseType: "blob" });

        downloadReport(response);
    },

    getInvoicesByClientId: async (clientId) => {
        const response = await axiosInstance.get(`/invoice/client/${clientId}`);
        return response.data;
    },

    deleteInvoiceById: async (invoiceId) => {
        const response = await axiosInstance.delete(`/invoice/deleteById/${invoiceId}`);
        return response.data;
    },

    downloadInvoice: async (payload) => {
        const response = await axiosInstance.post("/invoice/download", payload, { responseType: "blob" });

        downloadReport(response); 
    },

    downloadInvoiceExcel: async (payload) => {
        const response = await axiosInstance.post("/invoice/downloadExcel", payload, { responseType: "blob" });

        downloadReport(response);
    }
};